import { isBefore, startOfToday, subDays } from 'date-fns';

import type Validator from '../../models/Validator';

const TwentyEightDaysBeforeDateValidator: Validator = class {
  static isValid(value) {
    return !isNaN(Date.parse(value)) && !isBefore(value, subDays(startOfToday(), 28));
  }

  static getError() {
    return null;
  }
};

export default TwentyEightDaysBeforeDateValidator;
